import { IList } from "./common.model";

export interface walletInfoResponse {
  totalWalletAmount: number;
  lastPaymentDate: Date;
  lastPaymentDatePersian: string;
}

export interface getGroupedSalesResponse {
  groupedByBranches: IgroupedByBranches;
  groupedByIban: IgroupedByIban;
}

export interface IgroupedByBranches {
  result: IgroupedByBranchesResult[];
  totalCount: number;
  pageSize: number;
  pageNumber: number;
}
export interface IgroupedByBranchesResult {
  supplierName: string;
  branchName: string;
  totalFactorAmount: string;
  totalSettlementAmount: string;
}

export interface IgroupedByIban {
  result: IgroupedByIbanResult[];
  totalCount: number;
  pageSize: number;
  pageNumber: number;
  ibanId: number;
}
export interface IgroupedByIbanResult {
  ibanNumber: string;
  ibanOwner: string;
  totalFactorAmount: string;
  totalSettlementAmount: string;
}
export class getSalesByCustomerSearchRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: SaleSearchFilter | undefined;
}
export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
}
export class Filter {
  branchIds: number[] | undefined;
  branchStoreIds: IList[] | undefined;
  ibans: string[] | undefined;
  saleStatuses: string[] | undefined;
  customerMobileNumber: string | undefined;
  customerNationalCode: string | undefined;
  customerName: string | undefined;
  settlementDateFrom: Date[] | null | undefined;
  settlementDateTo: Date[] | null | undefined;
  settlementDate: Date[] | null | undefined;
  saleDateFrom: Date[] | null | undefined;
  saleDateTo: Date[] | null | undefined;
  saleDate: Date[] | null | undefined;
  uploadInvoiceDateFrom: Date[] | null | undefined;
  uploadInvoiceDateTo: Date[] | null | undefined;
  saleAmountFrom: string | null | undefined;
  saleAmountTo: string | null | undefined;
  settlementAmountFrom: string | null | undefined;
  settlementAmountTo: string | null | undefined;
}
export class SaleSearchFilter extends Filter {
  waitForSettlementDateFrom?: Date[] | null | undefined;
  waitForSettlementTo?: Date[] | null | undefined;
  settlementDeadlineDateFrom?: Date[] | null | undefined;
  settlementDeadlineDateTo?: Date[] | null | undefined;
  factorAmountFrom?: string | undefined;
  factorAmountTo?: string | undefined;
  // settlementAmountFrom?: string | undefined;
  // settlementAmountTo?: string | undefined;
  saleType?: string | undefined;
  factorDateFrom?: Date[] | null | undefined;
  factorDateTo?: Date[] | null | undefined;
  // saleAmountFrom?: string | undefined;
  // saleAmountTo?: string | undefined;
}
export interface IcustomerInfo {
  customerName: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  branchName: string;
  iBan: string;
  iBanOwner: string;
  // paymentDate: Date;
  paymentDatePersian: string;
  factorAmount: string;
  waitForSettlementDatePersian: string;
  saleKey: string;
  branchId: number;
  customerPersonId: number;
  sellerName: string;
  storeName: string;
  saleType: string;
  saleTypeTitle: string;
}
export interface IResult {
  customerName: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  branchName: string;
  iBan: string;
  iBanOwner: string;
  paymentDate: Date;
  paymentDatePersian: string;
  factorAmount: string;
  requestDate: Date;
  requestDatePersian: string;
  saleId: string;
  branchId: number;
  customerPersonId: number;
}
export interface IAwaitedFactorSalesResponse {
  saleKey: string;
  customerPersonId: number;
  branchId: number;
  customerName: string;
  mobileNumber: string;
  nationalCode: string;
  saleAmount: number;
  // customerApproveDate: Date;
  // requestForSettlementDate: Date;
  customerApproveDate_Persian: string;
  requestForSettlementDate_Persian: string;
  saleStatus: string;
  saleStatusTitle: string;
  saleTypeTitle: string;
  saleType: string;
}

export interface SearchSalesResponse {
  customerName: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  branchName: string;
  iBan: string;
  iBanOwner: string;
  factorAmount: number;
  settlementAmount: number;
  saleStatus: string;
  saleStatusPersian: string;
  paymentDate: Date;
  paymentDatePersian: string;
  waitForSettlementDate: Date;
  waitForSettlementDatePersian: string;
  saleKey: string;
  branchId: number;
  customerPersonId: number;
}
export interface openSaleResponse {
  saleKey: string;
  branchId: number;
  customerPersonId: number;
  customerName: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  saleAmount: number;
}
export interface SaleSearachResponse {
  customerNationalCode: string;
  customerMobileNumber: string;
  branchName: string;
  sellerName: string;
  paymentDatePersian: string;
  factorDatePersian: string;
  factorAmount: number;
  settlementAmount: number;
  settlementDatePersian: string;
  saleType: string;
  saleTypeTitle: string;
  saleStatus: string;
  saleStatusPersian: string;
  iBan: string;
  iBanOwner: string;
  waitForSettlementDatePersian: string;
  saleKey: string;
  branchId: number;
  customerPersonId: number;
}
